import React from 'react';
import { IMAGE_BASE } from '../constants/site';
import './MoneyPage.css';

const NewsArticle = () => (
  <div className="money-page">
    <h1>Vientiane Traffic Company Pioneers Road Safety Solutions for a Secure Tomorrow</h1>
    <p>
      Vientiane Traffic continues to lead innovative road safety solutions across Laos. With
      a proven track record in road markings, signage, and workplace safety, we partner with
      clients to raise safety standards on every project.
    </p>
    <h2>Why Choose Vientiane Traffic?</h2>
    <p>
      Our technologies ensure precision and durability in road markings. From warning signs to
      workplace safety plans, we provide comprehensive solutions tailored to each environment.
    </p>
    <h2>Client Testimonials</h2>
    <p>
      &ldquo;Impressed with the quality of road markings. Vientiane Traffic truly leads in
      safety solutions.&rdquo; &mdash; Satisfied Client
    </p>
    <h2>Join the Movement</h2>
    <p>
      Make safety a priority with Vientiane Traffic. Collaborate with us for solutions that
      redefine safety standards on streets and in workplaces.
    </p>
    <img src={`${IMAGE_BASE}/Picture1.png`} alt="Road safety illustration" />
  </div>
);

export default NewsArticle;
